import React from "react";
import { useTranslation } from "react-i18next";

import db from "astrid-firebase/src/db";
import organizationTypes from "astrid-firestore/src/api/organizations/constants/organizationTypes";
import producerRoles from "astrid-firestore/src/api/organizations/constants/producerRoles";
import publisherRoles from "astrid-firestore/src/api/organizations/constants/publisherRoles";
import useCollectionDataOnce from "astrid-firestore/src/hooks/useCollectionDataOnce";

import LoadingContext from "../../../ui/components/LoadingContext/LoadingContext";

import Todo from "./components/Todo";

export default function Todos({ todos, organization, language, loading, error }) {
	const { t } = useTranslation();

	const [productionManagers] = useCollectionDataOnce(
		organization &&
			db
				.collection("users")
				.where(
					`permissions.${organization.type}.${organization.id}`,
					"array-contains",
					organization.type === organizationTypes.PUBLISHER ? publisherRoles.RESOURCE : producerRoles.MANAGER,
				),
	);

	const managerOptions = productionManagers
		?.filter((user) =>
			language ? user?.[`${organization?.type}s`]?.[organization.id]?.languageOptions?.includes(language) : user,
		)
		.map((user) => ({
			id: user?.id,
			img: user?.img,
			name: user.firstName + " " + user.lastName,
			email: user?.email,
		}))
		.sort((a, b) => a.name.localeCompare(b.name), {});

	return (
		<LoadingContext data={todos} loading={loading} error={error} noDataAvailableMessage={t("noTodos", "No todos")}>
			{todos?.map((todo) => (
				<Todo
					key={todo.id}
					todo={todo}
					language={language}
					organization={organization}
					managerOptions={managerOptions}
				/>
			))}
		</LoadingContext>
	);
}
